import { is_natural } from '$lib/universal/lib.js';

export function match(param) {
    return is_natural(param);
}
